export default __webpack_public_path__ + "static/media/ER18.40d0c2f3.png";